import React from 'react'
import CarHireSearchBar from '../CarHireSearchBar/CarHireSearchBar'
import GlobalSearchContainerPane, { GlobalSearchContainerPaneContent } from 'components/Search/GlobalSearch/GlobalSearchContainerPane'
import GlobalSearchHeroContainer from 'components/Search/GlobalSearch/GlobalSearchHeroContainer'
import CarHireMobileSearchControls from '../CarHireMobileSearchControls/CarHireMobileSearchControls'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

function CarHirePageHeader() {
  return (
    <GlobalSearchHeroContainer
      heroImageId="fbuik31c2rvjvo7mtk2p"
      title="Car Hire"
    >
      <GlobalSearchContainerPane displayMobile>
        <GlobalSearchContainerPaneContent>
          <CSSBreakpoint min="tablet">
            <CarHireSearchBar />
          </CSSBreakpoint>
          <CSSBreakpoint max="mobile">
            <CarHireMobileSearchControls />
          </CSSBreakpoint>
        </GlobalSearchContainerPaneContent>
      </GlobalSearchContainerPane>

    </GlobalSearchHeroContainer>
  )
}

export default CarHirePageHeader
